<template>
  <div class="fund-record">
    <div class="fund-record-top">
      <div class="classification">
        <span :class="active==1?'active':''" @click="btnClick(1)">充值记录</span>
        <span>|</span>
        <span :class="active==2?'active':''" @click="btnClick(2)">提现记录</span>
      </div>
    </div>
    <div class="fund-record-bottom">
      <div v-if="active==1">
        <recharge-record-data></recharge-record-data>
      </div>
      <div v-if="active==2">
        <withdrawal-record-data></withdrawal-record-data>
      </div>
    </div>
  </div>
</template>

<script>
import RechargeRecordData from "./rechargeRecordData.vue";
import WithdrawalRecordData from "./withdrawalRecordData.vue";

export default {
  name: "FundRecord",
  data() {
    return {
      active: 1,
    };
  },
  mounted() {
    this.$nextTick(function() {});
  },
  beforeRouteEnter(to, from, next) {
    window.document.querySelector("body").setAttribute("style", "background-image:none");
    window.document.body.style.backgroundColor = "#EFEFEF";
    next();
  },
  beforeRouteLeave(to, from, next) {
    window.document.body.style.backgroundColor = "#001928";
    next();
  },
  methods: {
    btnClick(num) {
      this.active = num;
    },
  },
  components: {
    RechargeRecordData,
    WithdrawalRecordData,
  },
};
</script>

<style scoped lang="scss">
.fund-record {
  .fund-record-top {
    width: 98%;
    height: 60px;
    margin-left: 1%;
    margin-top: 16px;
    background-color: #ffffff;
    text-align: left;
    .classification {
      display: inline-block;
      line-height: 60px;
      margin-left: 1%;
      span {
        margin-right: 20px;
        color: #999999;
        font-size: 16px;
        cursor: pointer;
      }
      span.active {
        color: #0177BD;
        font-weight: 600;
      }
    }
  }
  .fund-record-bottom {
    width: 98%;
    background-color: #ffffff;
    margin-left: 1%;
    margin-top: 10px;
  }
}
</style>